// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609281830/js/" + chunkId + "." + {"44":"7b0694d5","225":"b9bfd7dd","481":"2c429d32","486":"8f624c07","770":"8f5026b5"}[chunkId] + ".0.6303267585063519.chunk.js";
};